import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import TopBar from '../../components/TopBar'
import Footer from '../../components/Footer'
import { Fade } from "react-awesome-reveal";
import { isMobileDevice } from "../../utils";
import { useLocation, useNavigate } from "react-router";
import Videos1 from "./components/videos1"
import { Swiper, SwiperSlide } from 'swiper/react';
import More from "./components/more";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const whySelectLi = [
    { key: 1, title: "天然的認證好柚木", content: "100%經過認證的合法，可持續，負責任的柚木家具，正因為純天然的且在木製家具的製程中不會釋放有害化學物質，最終也可經生物完全分解，不會對地球造成負擔。" },
    { key: 2, title: "愛護環境永續經營", content: "非法採伐破壞了許多天然森林，詩肯柚木堅持只使用人造柚木製成家具，因為在人工林中每砍伐一棵就必須種植一棵新樹。除了確保木料供應的穩定，也兼顧愛護地球保護森林永續發展。" },
    { key: 3, title: "經久耐用品質保證", content: "每件詩肯柚木家具都經過嚴謹的品質檢驗，確保送至您家府上的都是優質的成品。從家具的原料、接合處、配件直到最後修飾部分，每一個環節都不放過，致力將最好的產品與服務帶給顧客。" },
    { key: 4, title: "獲獎無數信譽可靠", content: "詩肯柚木獲獎無數，囊括多次新加坡潛質品牌、超級品牌及新加坡城市商業區域品牌。更於2012年榮獲富比士評選亞洲200家最佳中小企業獎，更是全世界唯二在日本的家具品牌，品質保證，絕對值得您信賴。" },
    { key: 5, title: "精湛工藝職人手作", content: "詩肯柚木向來以精湛手藝聞名四方。關鍵在於柚木在製成家具前會先經過一次機器磨砂，在製成後還會經過多一輪手工磨砂。正就是因為多層細膩的專業加工處理，詩肯柚木才會擁有完美無瑕的磨砂表層。" },
    { key: 6, title: "比您更在乎的細節", content: "甲醛存在於日常生活中，包括衣物、牙膏甚至口紅，詩肯柚木開業至今嚴謹要求家具製程並對甲醛釋出量嚴格把關，確保安全無虞並符合規定；而全柚木實木系列不但符合最高標準，美觀耐用深受消費者喜愛，敬請安心使用。" },
  ]

  const location = useLocation();
  const part1Ref = useRef(null);
  const part2Ref = useRef(null);

  useEffect(() => {
    // 检查 URL 中的 hash
    if (location.hash) {
      // 等待组件渲染完成
      setTimeout(() => {
        const element = document.getElementById(location.hash.slice(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="">
      <TopBar />
      <div className="relative"
        style={{
          backgroundImage: `url(${require("../../assets/image/video/icon7.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }} >
        <div className="text-[#181512] text-[45px] py-[118px] font-[700] w-[955px] mx-auto 
        h5:text-center h5:text-[30px] h5:w-full h5:py-[68px] relative z-10">關於詩肯</div>

        <div className="absolute top-0 left-0 right-0 bottom-0"
          style={{
            background: 'linear-gradient(to right, #fbfbfbc2, transparent)',
            bottom: '0',
            content: "",
            left: '0',
            pointerEvents: 'auto',
            position: 'absolute',
            right: '0',
            top: '0',
            zIndex: 1
          }}></div>
      </div>

      <div className="w-[1200px] mx-auto flex h5:block h5:w-full">
        <div className="flex-1 pt-[100px] h5:px-16 h5:pt-[60px]">
          <div className="text-[#181512] text-[30px] font-bold mt-[30px] mb-[30px]">心有多大，舞台就有多大</div>
          <div className="text-[#595959] text-[20px] mb-[30px]">創業就是有夢，最重要的是要有熱情和喜好，然後你會發現，只要用心經營，心有多大、舞台就有多大</div>
          <div className="text-[#595959] text-[20px] mb-[30px]">
            我們的足跡遍布世界各地，我們在德國、新加坡、台灣、日本、馬來西亞和美國等國家共有超過 150 間零售分店和旗艦店。
            在台灣，我們擁有最大的家具連鎖門市，全國有超過 120 間門市。無論在哪個門市，我們都將竭力為來訪的貴賓提供最溫馨、舒適的參觀經驗，讓客人踏進門市的第一步就有賓至如歸的感覺。
          </div>
          <div className="text-[#595959] text-[20px] mb-[30px]">歡迎蒞臨。</div>
          <div className="text-[#000] text-[18px] font-bold">PC Lim</div>
          <div className="text-[#595959] text-[18px]">Founder & Chairman, Scanteak</div>
        </div>
        <div className="w-[100px]"></div>
        <div className="flex-1 pt-[60px] h5:pl-[20px]">
          <img src={require("../../assets/image/video/icon8.png")} className="w-full" alt="" />
        </div>
      </div>

      <div className="w-[800px] mx-auto mb-[75px] py-[106px] h5:w-full h5:pt-[80px] h5:pb-0"
        id="part-1"
        ref={part1Ref}>
        <div className="text-[#181512] text-[40px] font-bold text-center mt-[30px] mb-10 h5:px-16">品牌文化</div>
        <div className="text-[#595959] text-[18px] text-center h5:px-16">
          詩肯柚木所製造的柚木家具品質一流，設計經典，歷久彌新。我們家具設計的創作靈感來自北歐丹麥，強調線條簡約。製成的家具實用、美觀、耐用，是營造溫馨舒適居住環境的理想選擇。
        </div>

        <div>
          <div className="relative mt-[100px] h5:mt-[50px]">
            <div className="absolute top-0 left-0 bottom-0 z-[-1] h5:left-[16px]">
              <img src={require("../../assets/image/video/icon9.png")}
                className="w-[557px] h-[723px] object-cover h5:w-[354px] h5:h-[358px]" alt="" />
            </div>
            <Fade cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
              <div className="py-[100px] pl-[50%] h5:pl-[10%] h5:mr-16 h5:pb-[50px]">
                <div className="bg-[#f6f5f1] py-[60px] px-[80px]  h5:px-[30px]">
                  <div className="text-[#181512] text-[30px] font-bold mb-[30px] h5:text-[26px]">品牌文化</div>
                  <div className="text-[#595959] text-[18px] h5:text-[16px]">
                    Scanteak 詩肯柚木，源自於結合北歐 Scandinavian 與柚木 Teak 的涵義而成為「Scanteak」, 意指北歐風格設計的精品柚木傢俱，也是詩肯品牌的由來。詩肯柚木一直以來堅持傳遞著家的感覺，及讓家更有家的感覺。走進詩肯，就如走進自己溫暖的家中，「Feel at home」專屬的生活美學環繞其中而不斷傳遞著。
                  </div>
                </div>
              </div>
            </Fade>
          </div>
          <div className="relative mt-[100px] h5:mt-[0px]">
            <div className="absolute top-0 right-0 bottom-0 z-[-1] h5:right-[16px]">
              <img src={require("../../assets/image/video/icon10.png")}
                className="w-[557px] h-[579px] object-cover h5:w-[300px] h5:h-[316px]" alt="" />
            </div>
            <Fade cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
              <div className="py-[100px] pr-[50%] h5:pr-[10%] h5:ml-16 h5:pb-[50px]">
                <div className="bg-[#f6f5f1] py-[60px] px-[80px]  h5:px-[30px]">
                  <div className="text-[#181512] text-[30px] font-bold mb-[30px]">品牌價值</div>
                  <div className="text-[#595959] text-[18px]">
                    Scanteak向來追求完美，精湛的工藝與細節的講究，造就了高品質兼具設計感的精品柚木傢俱，進而品味生活的美好與溫度。
                    詩肯柚木邀您一同體驗舒適而溫馨的生活態度與哲學。
                  </div>
                </div>
              </div>
            </Fade>
          </div>
          <div className="relative mt-[100px] h5:mt-[50px]">
            <div className="absolute top-0 left-0 bottom-0 z-[-1] h5:left-[16px]">
              <img src={require("../../assets/image/video/icon11.png")}
                className="w-[557px] h-[723px] object-cover h5:w-[354px] h5:h-[358px]" alt="" />
            </div>
            <Fade cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
              <div className="py-[100px] pl-[50%] h5:pl-[10%] h5:mr-16 h5:pb-[50px]">
                <div className="bg-[#f6f5f1] py-[60px] px-[80px]  h5:px-[30px]">
                  <div className="text-[#181512] text-[30px] font-bold mb-[30px] h5:text-[26px]">以人為本</div>
                  <div className="text-[#595959] text-[18px] h5:text-[16px]">
                    產品本身只能裝飾環境，不能構築一個完整的家。一個家終究應該以人為本。我們致力確保顧客在首次與我們接觸時，感受我們精心營造的溫馨舒適，並且希望這種感覺帶回自己家中。
                    <br />
                    在公司內，我們採用直接真誠，一對一溝通方式進行內部溝通，我們貫徹這樣的溝通方式，符合我們「由內到外」作風一致的品牌策略。
                  </div>
                </div>
              </div>
            </Fade>
          </div>
          <div className="relative mt-[100px] h5:mt-[0px]">
            <div className="absolute top-0 right-0 bottom-0 z-[-1] h5:right-[16px]">
              <img src={require("../../assets/image/video/icon12.png")}
                className="w-[557px] h-[579px] object-cover h5:w-[300px] h5:h-[316px]" alt="" />
            </div>
            <Fade cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
              <div className="py-[100px] pr-[50%] h5:pr-[10%] h5:ml-16 h5:pb-[50px]">
                <div className="bg-[#f6f5f1] py-[60px] px-[80px]  h5:px-[30px]">
                  <div className="text-[#181512] text-[30px] font-bold mb-[30px]">家外有家</div>
                  <div className="text-[#595959] text-[18px]">
                    從宏觀的角度來看，家不僅僅指的是居所，社會本身就是我們集體的居住環境。詩肯柚木有崇高的理想 — 推廣博愛仁慈、服務人群的社會精神。我們相信社會本身就是一個由許多小家庭組成的大家庭，推動每一個家庭的正向情感連結，一定能夠帶動社會的良善循環。
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>

      <div className=""
        style={{
          backgroundImage: `url(${require("../../assets/image/icon6.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
        <div className="w-[930px] mx-auto mb-[75px] py-[106px] h5:w-full"
          id="part-2"
          ref={part2Ref}>
          <div className="text-[#181512] text-[36px] font-bold text-center mt-[30px] mb-10 h5:px-16">為何選擇詩肯</div>
          <div className="text-[#595959] text-[18px] text-center h5:px-16">柚木以其耐用性和堅固性而聞名，即使在惡劣的氣候條件下也幾乎不需要維護。它不僅耐候性強，而且比其他任何木材都耐磨。它還具有防潮，防腐和防蟲的作用。</div>
          <div className="grid gap-10 grid-cols-3 h5:block">
            {
              whySelectLi.map((item: any, index) => (
                <Fade key={index}
                  cascade={true}
                  direction="up"
                  delay={200}
                  duration={800}
                  triggerOnce={true}
                >
                  <div className="mt-[75px] h5:mt-[60px]">
                    <img src={require(`../../assets/image/video/whyscanteak_${item?.key}.jpg`)} alt=""
                      className='w-[217px] mx-auto rounded-full object-cover hover:opacity-70  duration-300' />
                    <div className="text-[#181512] text-[20px] font-bold mt-[30px] mb-[30px] text-center h5:px-16">{item?.title}</div>
                    <div className="text-[#595959] text-[18px] text-center h5:px-16">{item?.content}</div>
                  </div>
                </Fade>
              ))
            }
          </div>
        </div>
      </div>


      <More />

      <Footer />
    </div>
  );
};

export default ComponentName;
